const config = {
  fbAppId: process.env.REACT_APP_FB_APP_ID,
  fbAppSecretId: process.env.REACT_APP_FB_SECRET_ID,
  googleClientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,
  googleClientSecret: process.env.REACT_APP_GOOGLE_CLIENT_SECRET,
  analyticsUrl: process.env.REACT_APP_ANALYTICS_ENDPOINT,
  frontendUrl: process.env.REACT_APP_FRONTEND_URL,
  web3BaseUrl: process.env.REACT_APP_WEB3_BE_ENDPOINT,
  web3AuthKey: process.env.REACT_APP_WEB3_BE_AUTHORIZATION_TOKEN,
  learningPortalUrl: process.env.REACT_APP_LEARNING_PORTAL_URL,
};

export default config;
